import { render, staticRenderFns } from "./EditTransportFeeModal.vue?vue&type=template&id=528ea6b0&scoped=true&"
import script from "./EditTransportFeeModal.vue?vue&type=script&lang=js&"
export * from "./EditTransportFeeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ea6b0",
  null
  
)

export default component.exports